import { buildRefreshParameters, getTabularReducerInfo } from "./common"
import { apiGet } from "../../utils/apiConnector"
import { emissionsApi } from "../../config/apiUrls"

// Thunk
export const refresh = () => {
  return (dispatch, getState) => {
    const state = getState()
    const ownerId = state.profile.id
    dispatch(actions.setLoading(true))
    return (
      apiGet(
        emissionsApi +
          "/" +
          ownerId /*buildRefreshParameters(storeId, state.emissions)*/,
      )
        .onOk((res) => {
          dispatch(actions.setData(res.data.response ? res.data.response : []))
          dispatch(actions.setTotalPages(res.data.response.pages || 1))
          dispatch(
            actions.setTotalCount(
              res.data.response.count || res.data.response.length || 1,
            ),
          )
        })
        // .useDefaultErrorHandlers(dispatch)
        .onFail(() => {
          dispatch(actions.setData([]))
          dispatch(actions.setTotalCount(0))
          dispatch(actions.setTotalPages(1))
        })
        .onCancel(() => {
          dispatch(actions.setData([]))
          dispatch(actions.setTotalCount(0))
          dispatch(actions.setTotalPages(1))
        })
        .afterAll(() => {
          dispatch(actions.setLoading(false))
        })
        .startSingle()
    )
  }
}

const { actions, reducer, thunks } = getTabularReducerInfo("MARKS", refresh)
export default reducer
export const { openPage, filter, clear, search, sort, setDateRange } = thunks
